import { CHART_TYPES } from '../../redux_store';

export const generateLineTypeChartData = (title, data, type) => {
  let xAxisData = [];
  let seriesData = [];
  const rootContainer = document.getElementById('dashboardInner');
  const root = rootContainer ? rootContainer.offsetWidth : 1024;

  const maxCharsPerLine = Math.max(10, Math.round(root / 80));

  data.forEach((item) => {
    if (type !== CHART_TYPES.PIE) {
      const words = item.name.split(' ');
      let lines = [];
      let currentLine = '';

      words.forEach(word => {
        if ((currentLine + ' ' + word).trim().length <= maxCharsPerLine) {
          currentLine = (currentLine + ' ' + word).trim();
        } else {
          if (currentLine) lines.push(currentLine);
          currentLine = word;
        }
      });
      if (currentLine) lines.push(currentLine);

      xAxisData.push(lines.join('\n'));
    } else {
      xAxisData.push(item.name);
    }
    seriesData.push(item.value);
  });

  const sortedData = data.sort(function(a, b) {
    return a.value - b.value;
  });
  return {
    title: {
      text: title,
      left: 20,
      top: 12,
      textStyle: {
        color: '#122056',
      },
    },
    grid: type !== CHART_TYPES.PIE ? {
      left: '3%',
      right: '4%',
      bottom: '1%',
      top: '20%',
      containLabel: true,
    } : null,
    gradientColor:
      type !== CHART_TYPES.PIE ? ['#5894e7', '#1B71E6', '#122056'] : null,
    visualMap: [
      {
        show: false,
        type: 'continuous',
        seriesIndex: type !== CHART_TYPES.PIE ? 0 : null,
        max: type !== CHART_TYPES.BAR ? sortedData[0].value : null,
        min:
          type !== CHART_TYPES.BAR
            ? sortedData[sortedData.length - 1].value
            : null,
        inRange:
          type === CHART_TYPES.PIE
            ? {
              colorLightness: [0.9, 0.4],
            }
            : null,
      },
    ],
    tooltip: {
      trigger: type === CHART_TYPES.PIE ? 'item' : 'axis',
    },
    yAxis: type !== CHART_TYPES.PIE ? { type: 'value' } : null,
    xAxis:
      type !== CHART_TYPES.PIE
        ? {
          type: 'category',
          data: xAxisData,
          axisLabel: {
            interval: 0,
            rotate: 0,
            color: '#122056',
            fontSize: 11,
            margin: 8,
            formatter: function(value) {
              return value;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        }
        : null,
    series: [
      type === CHART_TYPES.PIE
        ? {
          type: 'pie',
          radius: '55%',
          center: ['50%', '50%'],
          data: sortedData,
          roseType: 'radius',
          label: {
            color: '#122056',
          },
          labelLine: {
            lineStyle: {
              color: '#c4c4c4',
            },
            smooth: 0.2,
            length: 10,
            length2: 20,
          },
          itemStyle: {
            color: '#1B71E6',
            shadowBlur: 20,
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowColor: 'rgba(3,31,66,0.4)',
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 3,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0,0,0, 0.5)',
            },
          },
        }
        : {
          label:
            type !== CHART_TYPES.PIE
              ? {
                color: '#122056',
              }
              : null,
          type: type,
          showSymbol: false,
          data: seriesData,
          backgroundStyle: { color: 'rgba(180, 180, 180, 0.2)' },
          areaStyle: { color: '#bbd5ff' },
          itemStyle: {
            color: '#1B71E6',
            shadowBlur: 20,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowColor: 'rgba(3,31,66,0.4)',
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0,0,0, 0.5)',
            },
          },
        },
    ],
  };
};
